import { Link, NavLink } from 'react-router-dom'
import './AppMenu.scss'
import React, { useEffect, useRef, useState } from 'react'
import logo from './../../assets/images/office-free-header-logo.svg'
import { IContract } from 'types/ContractType'
import { IEmployeeSummary } from '../../types/Employee'
import EmployeeService from '../../service/EmployeeService'
import KvkkModal from '../home/KvkkModal'
import ContractService from '../../service/ContractService'
import AuthUtil from '../../utils/AuthUtil'
import NotificationService from '../../service/NotificationService'
import whatsAppIcon from '../../assets/icons/whatsapp-logo.svg'
import NotificationModal from '../ui/modal/NotificationModal'
import { Button } from 'primereact/button'
import ImageModal from '../ui/modal/ImageModal'
import Avatar from '../../assets/images/avatar.png'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from '../ui/LanguageSwitcher'
import { Badge } from 'primereact/badge'
import NotificationRow from './notification/NotificationRow'
import PushNotificationService from '../../service/PushNotificationService'
import { INotificationList, INotificationRequest, Notifications } from '../../types/PushNotificationType'
import { Paginator } from 'primereact/paginator'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Divider } from 'primereact/divider'
import { getCurrentEmployee } from 'utils/Miscellaneous'
import RequestHomeOfficeService from '../../service/RequestHomeOfficeService'

const AppMenu = () => {
  const PILOT_FIRMS = !!process.env.REACT_APP_PILOT_FIRMS
    ? process.env.REACT_APP_PILOT_FIRMS.split(',').map((str) => Number(str))
    : []

  const IS_PILOT_USER = !!PILOT_FIRMS?.length ? PILOT_FIRMS.includes(getCurrentEmployee()?.firmId || 0) : true

  const { t } = useTranslation()
  const [val, toggle] = React.useState(false)
  const [notificationBoxVisible, setNotificationVisible] = React.useState(false)
  const [employee, setEmployee] = useState<IEmployeeSummary>()
  const [kvkkModalDisplay, setKvkkModalDisplay] = useState<boolean>(false)
  const [kvkkButtonDisplay, setKvkkButtonDisplay] = useState<boolean>(false)
  const [kvkkContent, setKvkkContent] = useState<IContract | undefined>()
  const [manager, setManager] = useState<IEmployeeSummary>()
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [icon, setIcon] = useState<boolean>(false)
  const [visible, setVisible] = useState(false)
  const [imageModalVisible, setImageModalVisible] = useState(false)
  const [notificationRows, setNotificationRows] = useState(10)
  const [notificationFirst, setNotificationFirst] = useState(0)
  const [notificationPage, setNotificationPage] = useState(0)
  const contactPdfUrl = 'https://azcdn.koc.com.tr/legal/Koc_Holding_Iletisim_Sureci_Aydinlatma_Metni.pdf'
  const contactPhone = '0850 399 22 33'
  const contactWhatsAppUrl = 'https://api.whatsapp.com/send/?phone=908503992233&text&app_absent=0'
  const contactEmail = 'cozum@kocweb.com'
  const contactFormUrl = 'https://cozum.kocweb.com'
  const contanctWhasAppPermissionText = `${t('appmenu.whatsapp-permission-text')} ${t('appmenu.lightning-text')} 
                                            ${t('appmenu.click')}<a href="${contactPdfUrl}" target="_blank">${t(
    'appmenu.tr-click'
  )}</a>`

  const profileRef = useRef<any>(null)
  const box = useRef<any>(null)
  const messageBoxRef = useRef<any>(null)
  const messageButtonRef = useRef<any>(null)

  const [unreadMessageCount, setUnreadMessageCount] = useState<number>(0)
  const [messages, setMessages] = useState<INotificationList | undefined>()
  const [pendingApprovalCount, setPendingApprovalCount] = useState<number>(0)
  const request: INotificationRequest = { pageNumber: notificationPage, pageSize: notificationRows }

  useEffect(() => {
    getUnreadMessagesCount()
    // İlk açılışta tarih filtresi yok → tüm onay bekleyen talepler sayılır.
    getPendingApprovalCount()

    // Bildirim sayısı, onay ekranındaki filtreyle güncellenir: event'te tarih varsa o aralık,
    // yoksa (tarih filtresi yok) tüm bekleyenler sayılır.
    const handleUpdatePendingCount = (e: Event) => {
      const detail = (e as CustomEvent).detail
      if (detail?.startDate && detail?.endDate) {
        getPendingApprovalCount(new Date(detail.startDate), new Date(detail.endDate))
      } else {
        getPendingApprovalCount()
      }
    }
    window.addEventListener('updatePendingApprovalCount', handleUpdatePendingCount)

    return () => {
      window.removeEventListener('updatePendingApprovalCount', handleUpdatePendingCount)
    }
  }, [])

  useEffect(() => {
    if (employee !== undefined && (employee as IEmployeeSummary).hasPendingContract) {
      setKvkkButtonDisplay(true)
    } else setKvkkButtonDisplay(false)
  }, [employee])

  useEffect(() => {
    let employee = AuthUtil.getEmployeeSummary()
    if (employee) {
      employee._photoUrl = EmployeeService.getEmployeePhotoUrl(employee)
      setEmployee(employee)
    }
    let myManager = localStorage.getItem('employee')
    if (myManager !== null) {
      setManager(JSON.parse(myManager) as IEmployeeSummary)
    }
  }, [])

  useEffect(() => {
    outsideClickEvent(handleOutsideClick)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageModalVisible])

  useEffect(() => {
    outsideClickEvent(messageBoxOutsideClick)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationBoxVisible])

  const showKvkk = () => {
    getPendingContractList()
  }

  const sortMessages = (data: INotificationList) => {
    const sortedData = data.responseItems.sort(function (a, b) {
      return new Date(b.sentDate).valueOf() - new Date(a.sentDate).valueOf()
    })
    return sortedData
  }

  const handleOutsideClick = (event: any) => {
    if (
      box.current &&
      !box.current.contains(event.target) &&
      profileRef.current &&
      !profileRef.current.contains(event.target)
    ) {
      if (!imageModalVisible) {
        toggle(false)
      }
    }
  }
  const messageBoxOutsideClick = (event: any) => {
    if (
      messageButtonRef.current &&
      !messageButtonRef.current.contains(event.target) &&
      messageBoxRef.current &&
      !messageBoxRef.current.contains(event.target)
    ) {
      if (notificationBoxVisible) {
        setNotificationVisible(false)
      }
    }
  }
  const outsideClickEvent = (func: any) => {
    document.addEventListener('click', func)
    return () => document.removeEventListener('click', func)
  }

  const getUnreadMessagesCount = () => {
    PushNotificationService.GetUnreadNotifications().then((resp) => {
      setUnreadMessageCount(resp.data)
    })
  }

  const getPendingApprovalCount = (startDate?: Date, endDate?: Date) => {
    RequestHomeOfficeService.getPendingApprovalCount(startDate, endDate).then((resp) => {
      setPendingApprovalCount(resp.data)
    }).catch(() => {
      setPendingApprovalCount(0)
    })
  }
  const close = () => {
    setVisible(false)
    iconToggle()
  }
  const closeImageModal = () => {
    setImageModalVisible(false)
  }

  const showModal = () => {
    setVisible(true)
    iconToggle()
  }

  const getPendingContractList = () => {
    ContractService.getPendingContractList()
      .then((response) => {
        setKvkkContent(response.data[0])
        setKvkkModalDisplay(true)
      })
      .then(() => localStorage.setItem('kvkkDisplay', 'true'))
      .catch((e) => console.log(e))
  }

  const getProfilePictureBase64 = () => {
    return localStorage.getItem('employeePhoto')
  }

  const toggleExpander = () => {
    setIsExpanded(!isExpanded)
  }
  const iconToggle = () => {
    setIcon(!icon)
  }

  const askWhatsAppPermissions = () => {
    NotificationService.showCustomHtmlPopup(
      contanctWhasAppPermissionText,
      'info',
      t('overlaypanel-texts.info-header'),
      t('buttons.continue'),
      true,
      t('visitor.canceled')
    ).then((result) => {
      if (result.isConfirmed) window.open(contactWhatsAppUrl, '_blank')?.focus()
    })
  }

  const renderProfileDetail = () => {
    return (
      <div className={val ? 'of-profile-detail' : 'd-none'} ref={box}>
        <div className={'header'} />
        {/* <AsyncImage  className={'profile-photo'} src={employee._PhotoUrl} alt="" /> */}
        <img
          className={'profile-photo'}
          src={getProfilePictureBase64() !== '' ? 'data:image/png;base64,' + getProfilePictureBase64() : Avatar}
          alt=""
        />
        <Button
          className="profile-button"
          icon={getProfilePictureBase64() !== '' ? 'pi pi-pencil' : 'pi pi-plus'}
          onClick={() => {
            setImageModalVisible(true)
          }}
        />
        <div className={'profile-context mb-5'}>
          <div className={'fw-bold'}>{employee?.fullName}</div>
          <div className={'fw-normal'}>{employee?.positionName}</div>
          <div className={'fw-light'}>{employee?.departmentName}</div>
        </div>
        <div className={'px-4'}>
          <hr />
        </div>
        {imageModalVisible ? (
          <ImageModal
            visible={imageModalVisible}
            defaultPhoto={''}
            close={closeImageModal}
            getPicture={getProfilePictureBase64}
          />
        ) : null}
        {kvkkButtonDisplay ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className={'logout'} style={{ cursor: 'pointer' }} onClick={() => showKvkk()}>
            <div className={'px-4 pb-4 lh-1'}>
              <i className={'pi pi-align-left'} />
              <span className={'ms-3'}>{t('appmenu.kvkk-menu')}</span>
              <i className={'pi pi-chevron-right float-end'} />
            </div>
          </a>
        ) : null}
        <div className="px-4 pb-4 lh-1 exp-header">
          <i className="pi pi-globe" />
          <span className="ms-3">{t('profile.menu-items.language')}</span>
          <div className="float-end">
            <LanguageSwitcher />
          </div>
        </div>
        <div className={`expander ${isExpanded ? 'expanded' : ''}`}>
          <div className={'px-4 pb-4 lh-1 exp-header'} onClick={() => showModal()}>
            <i className={'pi pi-bell'} />
            <span className={'ms-3'}>{t('profile.menu-items.notification-settings')}</span>
            <i className={`pi pi-chevron-${icon ? 'down' : 'right'} float-end`} />
          </div>
          {visible && (
            <NotificationModal
              isManager={manager?.isManager!}
              setVisible={setVisible}
              visible={visible}
              close={close}
            />
          )}
          <div className={'px-4 pb-4 lh-1 exp-header'} onClick={toggleExpander}>
            <i className={'pi pi-comments'} />
            <span className={'ms-3'}>{t('profile.menu-items.contact-us')}</span>
            <i className={`pi pi-chevron-${isExpanded ? 'up' : 'down'} float-end`} />
          </div>
          <div className="exp-content">
            <ul>
              <li className="px-4 pb-4 lh1">
                <a href={`tel:${contactPhone}`}>
                  <i className={'pi pi-phone'} />
                  <span className={'ms-3'}>{contactPhone}</span>
                </a>
              </li>
              <li className="px-4 pb-4 lh1" onClick={askWhatsAppPermissions}>
                <img className="logo-img" src={whatsAppIcon} alt="whatsapp" />
                <span className={'ms-3'}>WhatsApp</span>
              </li>
              <li className="px-4 pb-4 lh1">
                <a href={`mailto:${contactEmail}`}>
                  <i className={'pi pi-envelope'} />
                  <span className={'ms-3'}>{contactEmail}</span>
                </a>
              </li>
              <li className="px-4 pb-4 lh1">
                <a href={`${contactFormUrl}`}>
                  <i className={'pi pi-list'} />
                  <span className={'ms-3'}>{t('profile.content.contact-settings.form')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {IS_PILOT_USER && AuthUtil.isAdmin(employee?.authList) && (
          <Link to="/evaluation" className={'logout'}>
            <div className={'px-4 pb-4 lh-1'}>
              <i className={'pi pi-list'} />
              <span className={'ms-3'}>{t('profile.menu-items.evaluation')}</span>
              <i className={'pi pi-chevron-right float-end'} />
            </div>
          </Link>
        )}

        <Link to="/logout" className={'logout'}>
          <div className={'px-4 pb-4 lh-1'}>
            <i className={'pi pi-sign-out'} />
            <span className={'ms-3'}>{t('profile.menu-items.logout')}</span>
            <i className={'pi pi-chevron-right float-end'} />
          </div>
        </Link>
      </div>
    )
  }
  const readOneMessage = (message: Notifications) => {
    if (!message.isRead) {
      PushNotificationService.ReadNotification(message.id).then((resp) => {
        if (resp.data.isTransactionSuccess) {
          PushNotificationService.GetNotifications(request).then((resp) => {
            setMessages({ totalCount: resp.data.totalCount, responseItems: sortMessages(resp.data) })
            getUnreadMessagesCount()
          })
        }
      })
    }
  }
  const readAll = () => {
    if (messages?.responseItems.some((item) => item.isRead === false)) {
      PushNotificationService.ReadAll().then((resp) => {
        if (resp.data.isTransactionSuccess) {
          PushNotificationService.GetNotifications(request).then((resp) => {
            setMessages({ totalCount: resp.data.totalCount, responseItems: sortMessages(resp.data) })
            getUnreadMessagesCount()
          })
        }
      })
    }
  }
  const onPaginatorChange = (event: any) => {
    setNotificationRows(event.rows)
    setNotificationFirst(event.first)
    setNotificationPage(event.page)
    console.log(event)

    PushNotificationService.GetNotifications({
      pageNumber: event.page + 1,
      pageSize: event.rows,
    }).then((resp) => {
      setMessages({ totalCount: resp.data.totalCount, responseItems: sortMessages(resp.data) })
    })
  }
  const renderNotification = () => {
    return (
      <div className={notificationBoxVisible ? 'notification-detail' : 'd-none'} ref={messageBoxRef}>
        <div className="d-flex justify-content-between">
          <p className="notification-header">{t('push-notification.notifications')}</p>
          {messages && messages?.responseItems.length > 0 && (
            <p
              className="mark-all"
              onClick={() => readAll()}
              style={
                messages?.responseItems.filter((item) => item.isRead === false).length === 0
                  ? { opacity: 0.5 }
                  : { opacity: 1 }
              }>
              {t('push-notification.mark-as-all-read')}
            </p>
          )}
        </div>
        <div className="message-box-container">
          {messages && messages.responseItems.length > 0 ? '' : <p>{t('push-notification.no-notifications')}</p>}
          {messages?.responseItems.map((message) => (
            <div onClick={() => readOneMessage(message)} key={message.id}>
              <NotificationRow message={message} />
            </div>
          ))}
        </div>
        <div>
          <Paginator
            first={notificationFirst}
            rows={notificationRows}
            totalRecords={messages?.totalCount}
            onPageChange={onPaginatorChange}
          />
        </div>
      </div>
    )
  }

  /* Visitor Section */
  const op = useRef<OverlayPanel>(null)
  const linkContainer = useRef<HTMLDivElement>(null)

  return (
    <nav className={'navbar navbar-expand-lg navbar-light bg-light of-header'}>
      <div className={'collapse navbar-collapse container'}>
        <a className={'navbar-brand'} href="/home">
          <img src={logo} className={'d-inline-block align-top'} alt="" />
        </a>
        <ul className="navbar-nav d-flex gap-2 align-items-center mt-2 mt-lg-0">
          <li className={'nav-item'}>
            <NavLink
              className={'nav-link'}
              style={{ color: '#45bfe5' }}
              activeStyle={{ color: 'white' }}
              activeClassName="active-link"
              to="/home">
              {t('nav-menu-items.homepage')}
            </NavLink>
          </li>

          {AuthUtil.isSecurity(employee?.authList) && (
            <>
              {AuthUtil.isSecurityFirmRes(employee?.authList) ? (
                <li className={'nav-item'}>
                  <NavLink
                    to="/tracing"
                    className={'nav-link'}
                    style={{ color: '#45bfe5' }}
                    activeStyle={{ color: 'white' }}
                    activeClassName="active-link"
                    onClick={(e) => {
                      e.preventDefault()
                      op?.current?.toggle(e, linkContainer.current)
                    }}>
                    <div className="d-flex align-items-center gap-2" ref={linkContainer}>
                      {t('nav-menu-items.visitor-tracking')}
                      <i
                        style={{ cursor: 'pointer' }}
                        className="pi pi-chevron-down"
                        onClick={(e) => op?.current?.toggle(e, linkContainer.current)}
                      />
                    </div>
                  </NavLink>

                  {/* Visitor pages menu (Common - Firm Offices) */}
                  <OverlayPanel id="visitorOverlay" ref={op} className="visitor-overlay">
                    <div className="d-flex flex-column gap-2">
                      <NavLink
                        exact
                        activeStyle={{ color: '#45bfe5' }}
                        to={{ pathname: '/tracing', state: { type: 'shared' } }}
                        style={{ fontSize: '14px', textDecoration: 'none', color: '#000' }}>
                        {t('nav-menu-items.visitor-common-office')}
                      </NavLink>

                      <Divider className="my-0" />

                      <NavLink
                        activeStyle={{ color: '#45bfe5' }}
                        to={{ pathname: '/firm-tracing', state: { type: 'firm' } }}
                        style={{ fontSize: '14px', textDecoration: 'none', color: '#000' }}>
                        {t('nav-menu-items.visitor-firm-office')}
                      </NavLink>
                    </div>
                  </OverlayPanel>
                </li>
              ) : (
                <li>
                  <NavLink
                    className={'nav-link'}
                    style={{ color: '#45bfe5' }}
                    activeStyle={{ color: 'white' }}
                    activeClassName="active-link"
                    to="/tracing">
                    {t('nav-menu-items.visitor-tracking')}
                  </NavLink>
                </li>
              )}

              <li className={'nav-item'}>
                <NavLink
                  className={'nav-link'}
                  style={{ color: '#45bfe5' }}
                  activeStyle={{ color: 'white' }}
                  activeClassName="active-link"
                  to="/campus-service-tracing">
                  {t('nav-menu-items.campus-service-tracking')}
                </NavLink>
              </li>

            </>
          )}

          {/* Uzaktan Çalışma Bildirimleri: yönetici onay ekranı — yalnızca yöneticilerde görünür. */}
          {employee?.isManager && (
            <li className={'nav-item'}>
              <NavLink
                className={'nav-link'}
                style={{ color: '#45bfe5' }}
                activeStyle={{ color: 'white' }}
                activeClassName="active-link"
                to="/remote-office-notification">
                <div className="d-flex align-items-center gap-2 position-relative">
                  {t('nav-menu-items.remote-office-notification')}
                  {pendingApprovalCount > 0 && (
                    <Badge value={pendingApprovalCount > 10 ? `10+` : pendingApprovalCount} severity={'danger'} />
                  )}
                </div>
              </NavLink>
            </li>
          )}

          <li className={'nav-item'}>
            <NavLink
              className={'nav-link'}
              style={{ color: '#45bfe5' }}
              activeStyle={{ color: 'white' }}
              activeClassName="active-link"
              to="/calendar">
              {t('nav-menu-items.calendars')}
            </NavLink>
          </li>

          {AuthUtil.canSeeDashboard(employee?.authList) && (
            <li className={'nav-item'}>
              <NavLink
                className={'nav-link'}
                style={{ color: '#45bfe5' }}
                activeStyle={{ color: 'white' }}
                activeClassName="active-link"
                to="/dashboard">
                {t('nav-menu-items.statistics')}
              </NavLink>
            </li>
          )}

          {AuthUtil.isAdmin(employee?.authList) ? (
            <li className={'nav-item'}>
              <a
                className={'nav-link'}
                href={process.env.REACT_APP_REDIRECT_ADMIN_URL!}
                style={{ color: '#45bfe5' }}
                target="_blank"
                rel="noreferrer">
                {t('nav-menu-items.admin-panel')}
              </a>
            </li>
          ) : null}

          <li className="nav-item">
            <div
              onClick={() => {
                setNotificationVisible(!notificationBoxVisible)
                if (!notificationBoxVisible) {
                  PushNotificationService.GetNotifications(request).then((resp) => {
                    setMessages({ totalCount: resp.data.totalCount, responseItems: sortMessages(resp.data) })
                  })
                }
              }}
              ref={messageButtonRef}>
              <Button icon="pi pi-bell" className="p-button-rounded me-2 notification-button">
                {unreadMessageCount > 0 && (
                  <Badge
                    value={unreadMessageCount > 10 ? `10+` : unreadMessageCount}
                    className="notification-badge"
                    severity={'info'}
                  />
                )}
              </Button>
            </div>
          </li>
          <li className={'nav-item'}>
            {employee && (
              <div className={'of-profile'} ref={profileRef} onClick={() => toggle(!val)}>
                {/*<AsyncImage  className={'d-inline-block align-top of-profile-photo'} src={employee._PhotoUrl} alt="" />*/}
                <img
                  className={'d-inline-block align-top of-profile-photo'}
                  src={getProfilePictureBase64() !== '' ? 'data:image/png;base64,' + getProfilePictureBase64() : Avatar}
                  alt=""
                />
                <i className={val ? 'pi pi-angle-up of-profile-icon' : 'pi pi-angle-down of-profile-icon'} />
              </div>
            )}
          </li>
        </ul>
      </div>

      <KvkkModal
        display={kvkkModalDisplay}
        onHide={() => setKvkkModalDisplay(false)}
        onSubmit={(e) => {
          setKvkkButtonDisplay(false)
          setKvkkModalDisplay(false)
        }}
        content={kvkkContent}
      />

      {renderProfileDetail()}
      {renderNotification()}
    </nav>
  )
}

export default AppMenu
